export const npcPortraitFrames = {
  oldmanPortrait: 1159,
  yukiPortrait: 1034,
  satoshiPortrait: 1018,
  kojiPortrait: 1026,
  mariPortrait: 1030,
  naokoPortrait: 1022,
  hanaPortrait: 1038,
  randyPortrait: 1014, 
  npc1Portrait: 1042,
  npc2Portrait: 1155,
  npc3Portrait: 1147,
  npc4Portrait: 1143,
  npc5Portrait: 1182,
  
  // fallback frame index
  default: 1163,
};